import React from 'react';
import SectionTitle from '../../../components/SectionTitle';
import Cards from '../../../components/Cards';
import Divider from '../../../components/Divider';
import { StyledAccurateTesting } from './styles/StyledAccurateTesting';

const AccurateTesting = ({ content, bgColor }) => {
  return (
    <StyledAccurateTesting bgColor={bgColor} style={{backgroundColor: bgColor}} id="accurate-testing">
      <div className="rn-section-gap">
        <div className="container">
          <Divider {...content.divider} />
          <SectionTitle {...content.sectionTitle} />
          <Cards content={content.cards} />
        </div>
      </div>
    </StyledAccurateTesting>
  );
};

export default AccurateTesting;
